import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("gsm_token");
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401) {
      const path = window.location.pathname;
      // Public institute websites — never bounce visitors to admin login. Just clear stale creds.
      const PUBLIC_PREFIXES = ["/polyaurangabad", "/mitest", "/foodtech", "/cidco", "/vendor"];
      const isPublic = PUBLIC_PREFIXES.some(
        (p) => path === p || path.startsWith(p + "/")
      );
      const loginPath = path.startsWith("/institute") ? "/institute/login" : "/admin/login";
      if (isPublic) {
        localStorage.removeItem("gsm_token");
        localStorage.removeItem("gsm_user");
      } else if (path !== loginPath) {
        localStorage.removeItem("gsm_token");
        localStorage.removeItem("gsm_user");
        window.location.assign(loginPath);
      }
    }
    return Promise.reject(err);
  }
);

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export default api;
